export const ScreenType = {
  ALL_SCREEN: 0,
  SOICAL_WALL: 1,
  LEADER_BOARD: 2,
  ANALYTICS: 3,
  SOICAL_WALL_WITH_LEADER_BOARD: 4,
  SOICAL_WALL_WITH_ANALYTICS: 5,
};
export const ANIMATION_DURATION = 5000;
export const ANIMATION_DELAY_ON_EACH = 7000;
export const initialScreen = {
  title: "Dashboards",
  description: null,
  key: "1",
  duration: null,
  brands: null,
  sections: null,
  onlyWidgets: null,
  isDashboard: false,
  isDeepDive: false,
  isDeepDiveDashboard: false,
  deep_dive: {
    infoBar: null,
    mentions: null,
    wordcloud: [],
    category: [],
    top_users: [],
    influencers: [],
    source_of_post: [],
    locations: [],
    twitter_trend: null,
  },
  deepdive: { deepdiveResponse: [], tabName: null },
  pills: "All Dashboards",
  sortOrder: "asc",
  sortBy: "name",
  dashboard_template_filters: {
    filter_vals: [],
    search_text: "",
    pill: "All Dashboards",
    offset: 0,
    no_of_rows: 12,
    sort_expression: null,
    sort_order: null,
    type: "dashboard",
  },
  selected_duration_type: "Today",
  tagcloud_filter_pill: null,
  settings: {
    is_competitor: false,
    is_share_of_voice: false,
    color_style: "1",
    number_of_words: 50,
    font_family: "",
    post_presence_time: 5,
    post_presence_unit: "S",
    radius_attribute: null,
    number_of_nodes: 5,
  },
  category_screen_filters: [],
  country_state_city_filters: [
    {
      attribute: "twitter_trend_country",
      type: "varchar",
      columns: [
        {
          name: "IN",
          type: "include",
          display_name: "India",
          country_code: "IN",
        },
      ],
    },
  ],
  stream_screen_brand: null,
  current_screen_brand: null,
  stream_screen_filters: [],
  stream_screen_default_widget: null,
  quick_filter: null,
  profiles: null,
  adsset_list: [],
  adsset_value: null,
  ads_list: [],
  ads_value: null,
  selected_quick_profile: null,
  campaign_date: null,
  markInfluencersList: [],
  markInfluencersFlag: false,
  deletePostFlag: false,
};
export const globalChartColor = [
  "#3076F7",
  "#9D48FF",
  "#60E340",
  "#FFB940",
  "#3FE7AC",
  "#8397F1",
  "#2968B9",
  "#00A669",
  "#FF7D6C",
  "#00CED1",
  "#A77B00",
  "#FF2EF2",
  "#B600AA",
  "#8B4513",
  "#39A7E4",
  "#6600DA",
  "#FFC1B9",
  "#FF9C73",
  "#FFD58B",
  "#96FF7C",
  "#6A8CFD",
  "#FF6E31",
  "#FF83F7",
  "#CD97FF",
  "#FFBE00",
  "#E84500",
  "#19CDCE",
  "#708090",
  "#FF4343",
];
export const LineStyles = {
  Solid: "Solid",
  ShortDash: "Short Dash",
  ShortDot: "Short Dot",
  ShortDashDot: "Short Dash Dot",
  ShortDashDotDot: "Short Dash Dot Dot",
  Dot: "Dot",
  Dash: "Dash",
  LongDash: "Long Dash",
  DashDot: "Dash Dot",
  LongDashDot: "Long Dash Dot",
  LongDashDotDot: "Long Dash Dot Dot",
};
export const HeatMapEnum = {
  color: {
    gray: "#757575",
  },
  backgroundColor: {
    gray: "#757575",
  },
  datalabelColor: {
    gray: "#757575",
  },
};
// Default values for each chart type
export const DEFAULT_CHART_SETTINGS = {
  [`bar`]: {
    alpha: 15,
    beta: 15,
    depth: 100,
  },
  [`horizontal-bar`]: {
    alpha: 0,
    beta: 0,
    depth: 100,
  },
  [`pie`]: {
    alpha: 45,
    beta: 15,
    depth: 100,
  },
  [`area`]: {
    alpha: 20,
    beta: 5,
    depth: 50,
  },
  [`donut`]: {
    alpha: 45,
    beta: 15,
    depth: 100,
  },
};
export const NPS_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const ElementTypeEnum = {
  input: 1,
  textarea: 2,
  customDropdown: 3,
  radios: 4,
  rating: 5,
  checkbox: 6,
  takePicture: 7,
  termsConditions: 8,
};

export const screensWithPersistedFilters = [
  "000-000-551",
  "000-000-552",
  "000-000-556",
  "000-000-558",
  "000-000-559",
];
export const dummyMultiLineChartData = {
  data: {
    kpi: [],
    line: [
      {
        data: [
          {
            x: [
              "Redundant",
              "Verified Users on Twitter",
              "Users with Followers more than 5000",
              "Media House & Journalists",
            ],
            data: [
              {
                name: "Mention Count",
                y: [402, 53, 37, 18],
                color: "#000000",
                attribute: "tagid",
              },
              {
                name: "Post Likes",
                y: [8, 0, 0, 0],
                color: "#000000",
                attribute: "NumLikesCount",
              },
              {
                name: "Post Comments",
                y: [65, 5, 0, 8],
                color: "#000000",
                attribute: "NumCommentsCount",
              },
            ],
          },
        ],
        stacked: true,
      },
    ],
  },
  refresh_ri: false,
};
export const postCardUserbrandPrivateMessagesId = [
  17, 40, 48, 70, 89, 90, 60, 66, 54,
];
export const postCardUserBrandCommentId = [
  8, 12, 14, 15, 19, 22, 27, 32, 34, 36, 39, 45, 47, 51, 52, 77, 81, 83,
];

export const restrictedColors = [
  "#0c3b7c",
  "#072f54",
  "#0869aa",
  "#185edf",
  "#185edf",
  "#144be1",
  "#2968b9",
  "#1877f2",
  "#1da2ff",
  "#2f84ed",
  "#19bfe5",
  "#19bfe5",
  "#14abce",
  "#0e76a8",
  "#c50000",
  "#b92131",
  "#dc1e1e",
  "#dc1e1e",
  "#b92131",
  "#b19587",
  "#ff0033",
  "#ff3d00",
  "#ff5622",
  "#ff6230",
  "#ff763f",
  "#ffa02f",
  "#ff8d94",
  "#ff4487",
  "#f00075",
  "#f83a99",
  "#daa520",
  "#deaa0c",
  "#ffd000",
  "#ffd700",
  "#e10e50",
  "#f2c508",
  "#ffe684",
  "#cdb200",
  "#d2b48c",
  "#751bdc",
  "#751bdc",
  "#ce30f4",
  "#ce30f4",
  "#ac52ff",
  "#da26fc",
  "#54d600",
  "#60ca3b",
  "#6bd82d",
  "#678bff",
  "#10c34b",
  "#21b496",
  "#129c30",
  "#9df34b",
  "#a1fea7",
  "#bbe347",
  "#d3d3d3",
  "#b9bfd0",
  "#696969",
  "#8e5106",
  "#acff77",
  "#a82400",
  "#ff69b4",
];

export const sampleDataForMap = [
  {
    lat: 40.7128,
    lng: -74.006,
    averageRating: 4.5, // Used to determine the color (green in this case)
    totalResponses: 25, // Used to scale the marker's size
    category: "bank", // Determines the border color (e.g., blue for banks)
    ratingThisWeek: 4.7,
    ratingLastWeek: 4.4,
    responsesThisPeriod: 30,
    responsesLastPeriod: 20,
    feedback: [
      { name: "Service", score: 4.8 },
      { name: "Cleanliness", score: 4.5 },
    ],
  },
  {
    lat: 34.0522,
    lng: -118.2437,
    averageRating: 3.2, // Yellowish indicator for medium rating
    totalResponses: 40,
    category: "ATM", // Border color could be orange for ATMs
    ratingThisWeek: 3.5,
    ratingLastWeek: 3.0,
    responsesThisPeriod: 35,
    responsesLastPeriod: 45,
    feedback: [
      { name: "Service", score: 3.2 },
      { name: "Cleanliness", score: 3.5 },
    ],
  },
  {
    lat: 41.8781,
    lng: -87.6298,
    averageRating: 2.8, // Low rating; should appear red
    totalResponses: 15,
    category: "branch", // Another category (customize border color accordingly)
    ratingThisWeek: 2.9,
    ratingLastWeek: 2.7,
    responsesThisPeriod: 10,
    responsesLastPeriod: 15,
    feedback: [
      { name: "Service", score: 2.8 },
      { name: "Cleanliness", score: 2.9 },
    ],
  },
  {
    lat: 29.7604,
    lng: -95.3698,
    averageRating: 4.0, // Moderate rating
    totalResponses: 60,
    category: "bank",
    ratingThisWeek: 4.1,
    ratingLastWeek: 3.9,
    responsesThisPeriod: 70,
    responsesLastPeriod: 65,
    feedback: [
      { name: "Service", score: 4.2 },
      { name: "Cleanliness", score: 4.0 },
    ],
  },
];
export const supportedBenchmarkTraceDashboardTypes = [
  "competition",
  "benchmarking",
];
export const benchmarkAggregation = [
  { label: "Minimum", value: "min" },
  { label: "Maximum", value: "max" },
  { label: "Average", value: "avg" },
  { label: "Median", value: "median" },
  { label: "Custom", value: "custom" },
];
export const supportedBenchmarkTraceChartTypes = [
  "line",
  "bar",
  "horizontal-bar",
  "area",
  "pie",
  "donut",
  "lollipop",
  // "combination",
];

export const supportedChartTypesForPeakAndValley = [
  "bar",
  "horizontal-bar",
  "grid",
  "pivot-grid",
];
export const MAX_TUTORIAL_GUIDE_SKIP = 3;

export const sentimentClass = {
  Neutral: "mention-neutral",
  Positive: "mention-positive",
  Negative: "mention-negative",
};
export const TREEMAP_DEFAULT_HEIGHT = 650; // Default height for treemap charts
export const dummyTreeMap = {
  chart: {
    height: 600,
  },
  series: [
    {
      type: "treemap",
      name: "Norge",
      allowTraversingTree: true,
      layoutAlgorithm: "squarified",
      alternateStartingDirection: true,
      dataLabels: {
        format: "{point.name}",
        style: {
          textOutline: "none",
        },
      },
      borderColor: "#ffffff",
      borderRadius: 3,
      levels: [
        {
          level: 1,
          layoutAlgorithm: "squarified",
          dataLabels: {
            headers: true,
            enabled: true,
            style: {
              fontSize: "0.6em",
              fontWeight: "normal",
              textTransform: "uppercase",
            },
          },
          borderColor: "#333",
          borderRadius: 3,
          borderWidth: 1,
          colorByPoint: true,
        },
        {
          level: 2,
          dataLabels: {
            enabled: true,
            inside: false,
          },
        },
      ],
      data: [
        {
          id: "A",
          name: "Nord-Norge",
          color: "#50FFB1",
        },
        {
          id: "B",
          name: "Trøndelag",
          color: "#F5FBEF",
        },
        {
          id: "C",
          name: "Vestlandet",
          color: "#A09FA8",
        },
        {
          id: "D",
          name: "Østlandet",
          color: "#E7ECEF",
        },
        {
          id: "E",
          name: "Sørlandet",
          color: "#A9B4C2",
        },
        {
          name: "Troms og Finnmark",
          parent: "A",
          value: 70923,
        },
        {
          name: "Nordland",
          parent: "A",
          value: 35759,
        },
        {
          name: "Trøndelag",
          parent: "B",
          value: 39494,
        },
        {
          name: "Møre og Romsdal",
          parent: "C",
          value: 13840,
        },
        {
          name: "Vestland",
          parent: "C",
          value: 31969,
        },
        {
          name: "Rogaland",
          parent: "C",
          value: 8576,
        },
        {
          name: "Viken",
          parent: "D",
          value: 22768,
        },
        {
          name: "Innlandet",
          parent: "D",
          value: 49391,
        },
        {
          name: "Oslo",
          parent: "D",
          value: 454,
        },
        {
          name: "Vestfold og Telemark",
          parent: "D",
          value: 15925,
        },
        {
          name: "Agder",
          parent: "E",
          value: 14981,
        },
      ],
    },
  ],
  title: {
    text: "Norwegian regions and counties by area",
    align: "left",
  },
  subtitle: {
    text: 'Source: <a href="https://snl.no/Norge" target="_blank">SNL</a>',
    align: "left",
  },
  tooltip: {
    useHTML: true,
    pointFormat:
      "The area of <b>{point.name}</b> is \
            <b>{point.value} km<sup>2</sup></b>",
  },
};
export const dummyAPIResponse = {
  data: {
    kpi: [],
    treemap: [
      {
        data: [
          {
            x: ["Anchor", "Automobile", "Automobile Journalist"],
            data_source: "mentions",
            y: [54, 4, 2],
            color: "#000000",
          },
        ],
        bar_type: false,
        stacked: false,
        log: false,
        trace_name: "",
        min: 0,
        max: 54,
      },
    ],
  },
  refresh_ri: false,
};
